import fetch from 'isomorphic-fetch';
import { API } from '../../config';

export const getAllThemes = async () => {
  try {
    const response = await fetch(`${API}/themes`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};
export const getSingleTheme = async (id) => {
  try {
    const response = await fetch(`${API}/theme/${id}`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

